module.exports = __webpack_public_path__ + "sweat.svg?587fdf465e6bb8a0c4bea1a121704770";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feelings2/sweat.svg
// module id = 87
// module chunks = 0